export const BLOG_LIMITS = {
    title: 160,
    excerpt: 400,
    body: 50_000,
    metaTitle: 120,
    metaDescription: 320,
    products: 8,
};
//# sourceMappingURL=blog.js.map